import React from 'react';

import { FaFacebook, FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
const Footer = () => {
    const date = new Date()
    const year = date.getFullYear()
    return (
        <footer className="soc mt-4">

            <span className='d-flex justify-content-center gap-4 mb-4'>
                <a href="https://www.facebook.com/asaduzzaman.soumit.5"
                    style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='fb' target="blank"><FaFacebook style={{ fill: 'white' }} fontSize="24" /></a>

                <a href="https://www.instagram.com/asaduzzamansoumit/" style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='in' target="blank"><FaInstagram style={{ fill: 'white' }} fontSize="24" /></a>

                <a href="https://www.linkedin.com/in/mohammad-asaduzzaman-5512441aa/"
                    style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='link' target="blank"><FaLinkedin style={{ fill: 'white' }} fontSize="24" /></a>

                <a href="https://github.com/asaduzzaman599"
                    style={{ color: "#fff", padding: "10px", borderRadius: "50%" }} className='git' target="blank"><FaGithub style={{ fill: 'white' }} fontSize="24" /></a>

            </span>
            <p className="cr">Copyright&copy; {year} by asaduzzamansoumit@gmail.com All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;